export const messages = {
  minCharacters: '8 characters minimum',
  oneLetter: 'One lowercase character',
  oneUppercase: 'One uppercase character',
  oneSpecialCharacter: 'One special character',
  oneNumber: 'One number',
};
